export async function ptlGetOrderByToteUseCase(tote_barcode, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_get_order_by_tote(tote_barcode);

    const entity = new shipmentRepository.model_ptl_assemble(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("Shipment ptl inválido");
    }

    return entity;
}